export const copyToClipboard = () => {
  const copyItemElements = document.querySelectorAll(".js-copy");

  if (copyItemElements.length) {
    copyItemElements.forEach((copyItemElement) => {
      const hintText = copyItemElement.querySelector(".js-hint");

      function copyTextElement() {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(copyItemElement.dataset.copy.trim())
            .then(() => {
              showTooltip();
            })
            .catch((err) => {
              console.log("Something went wrong", err);
            });
        } else {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(copyItemElement);
          selection.removeAllRanges();
          selection.addRange(range);

          try {
            document.execCommand("copy");
            selection.removeAllRanges();

            showTooltip();
          } catch (error) {
            console.log("Something went wrong", error);
          }
        }
      }

      function onCopyElementClick() {
        copyTextElement();
      }

      function showTooltip() {
        hintText.classList.add("copy__hint--show");

        setTimeout(function () {
          hintText.classList.remove("copy__hint--show");
        }, 1000);
      }

      copyItemElement.addEventListener("click", onCopyElementClick);
    });
  }
};
